import { pluginFactory } from '@atlaskit/editor-common/utils';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { AiQuickPromptAction, AiQuickPromptState, EligibleRange } from './types';

export const pluginKey = new PluginKey<AiQuickPromptState>('aiQuickPromptPlugin');

export const initialState: AiQuickPromptState = {
	isPromptVisible: false,
	eligibleNodeRange: null,
};

export function reducer(
	state: AiQuickPromptState,
	action: AiQuickPromptAction,
): AiQuickPromptState {
	switch (action.type) {
		case 'SHOW_PROMPT':
			return action.range
				? {
						isPromptVisible: true,
						eligibleNodeRange: action.range,
					}
				: state;
		case 'HIDE_PROMPT':
			return {
				isPromptVisible: false,
				eligibleNodeRange: null,
			};
		default:
			return state;
	}
}

export const { createPluginState, createCommand, getPluginState } = pluginFactory(
	pluginKey,
	reducer,
	{
		mapping: (tr, pluginState) => {
			let newState = pluginState;

			if (newState.eligibleNodeRange) {
				const newFrom = tr.mapping.map(newState.eligibleNodeRange.from);
				const newTo = tr.mapping.map(newState.eligibleNodeRange.to);
				if (
					newFrom !== newState.eligibleNodeRange.from ||
					newTo !== newState.eligibleNodeRange.to
				) {
					newState = {
						...newState,
						eligibleNodeRange: { from: newFrom, to: newTo },
					};
				}
			}

			return newState;
		},

		// Hide the prompt when the selection changes
		onSelectionChanged: (_tr, pluginState, editorState) => {
			let newState = pluginState;

			if (newState.isPromptVisible && newState.eligibleNodeRange) {
				const { from, to } = newState.eligibleNodeRange;
				const sel = editorState.selection;
				if (sel.from !== from || sel.to !== to) {
					newState = {
						...newState,
						isPromptVisible: false,
						eligibleNodeRange: null,
					};
				}
			}

			return newState;
		},
	},
);

export const createShowPromptCommand = (range: EligibleRange) =>
	createCommand<AiQuickPromptAction>(() => {
		return {
			type: 'SHOW_PROMPT',
			range,
		};
	});

export const hidePromptCommand = createCommand<AiQuickPromptAction>({
	type: 'HIDE_PROMPT',
});
